export function OutlineStarIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3L14.7216 8.712L21 9.5376L16.4064 13.896L17.5632 20.1168L12 17.0976L6.4368 20.1168L7.5936 13.896L3 9.5376L9.2736 8.712L12 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
